// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"6fc5f4d4","759":"bbf431a0"}[chunkId] + ".chunk.js";
};